import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import withDataConsumer from '../../api/contextApi/withDataConsumer';
import './Admin.css';
import Login from './Login';
import MessageForm from './MessageForm';
import LogOut from './LogOut';

class Admin extends Component {
  render() {
    const { loggedIn } = this.props.context;
    return (
      <Switch>
        <Route exact path="/admin" component={Login} />
        {loggedIn && <Route exact path="/admin/message" component={MessageForm} />}
        {loggedIn && <Route exact path="/admin/logout" component={LogOut} />}
        <Route render={() => <Redirect to="/admin" />} />
      </Switch>
    );
  }
}

export default withDataConsumer(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin/index.js